module.exports = __webpack_public_path__ + "static/media/atom.75ec0815.png";